import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';

type PublishToBundleProps = {
  isOpen: boolean;
  close: () => void;
  archive: (programId: number) => void;
  programId: number;
};

export const RemoveFromBundle = ({
  isOpen,
  close,
  archive,
  programId,
}: PublishToBundleProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={close}
      title="Archive program"
      disableBackdropClick={true}
      footerClassName="p-0"
      modalClassName="w-full md:w-[572px]"
      modalContentClassName="overflow-hidden"
    >
      <div className="flex flex-col gap-6">
        <Typography variant="body" size="large" fontWeight="normal">
          This program is part of a live bundle. By archiving the program, you
          will remove it from there.
        </Typography>
        <div className="flex flex-col md:flex-row justify-between">
          <Button
            variant="text"
            color="neutral"
            onClick={close}
            className="w-full md:w-[254px]"
          >
            Cancel
          </Button>
          <Button
            onClick={() => archive(programId)}
            color="neutral"
            className="w-full md:w-[254px]"
          >
            Archive
          </Button>
        </div>
      </div>
    </Modal>
  );
};
